import { useCustomerSupport } from '@app/context/CustomerSupportContext'
import { usePublicDomainsReadContext } from '@app/context/PublicDomainsContext'
import { useSessionLanguage } from '@app/context/SessionSettingsContext'

import { getContactUsLink } from '@utils/companyName.utils'

const dispatchOpenChat = (): void => {
  const event = document.createEvent('Event')
  event.initEvent('open-hubspot-chat', true, true)
  document.dispatchEvent(event)
}

interface UseOpenChatReturn {
  dispatchOpenChat: () => void
  isLoading: boolean
}

export const useDispatchOpenChat = (): UseOpenChatReturn => {
  const { enabledContacts = [], isLoading } = useCustomerSupport()
  const { domains } = usePublicDomainsReadContext()
  const locale = useSessionLanguage()

  const safeDispatchOpenChat = () => {
    if (enabledContacts.length === 0) {
      window.open(
        getContactUsLink(domains, locale),
        '_blank',
        'location=yes,height=570,width=520,scrollbars=yes,status=yes'
      )
      return
    }

    dispatchOpenChat()
  }

  return { dispatchOpenChat: safeDispatchOpenChat, isLoading }
}
